import { Container, hooks, Icon, Spacer, Text } from 'roadie-ui'
import Panel, { PanelTitle } from 'components/layout/Panel'
import { LocalizedRichText, LocalizedText } from 'localization'
import type { TranslationKey } from 'localization'

const STOP_TYPE_KEYS = [
  'dweb_dashboard_on_time_rate_calculation_section_starting_gigs',
  'dweb_common_pickups',
  'dweb_common_deliveries',
  'dweb_common_returns',
] as const satisfies readonly TranslationKey[]

const IMPACTS_RATE_KEYS = [
  'dweb_dashboard_on_time_rate_calculation_section_not_meeting_expected_arrival_times',
  'dweb_dashboard_on_time_rate_calculation_section_gig_removals_due_inactivity',
] as const satisfies readonly TranslationKey[]

const DOES_NOT_IMPACT_RATE_KEYS = [
  'dweb_dashboard_on_time_rate_calculation_section_wait_times_pickup',
  'dweb_dashboard_on_time_rate_calculation_section_traffic_delays',
] as const satisfies readonly TranslationKey[]

const IconRow: React.FC<{ icon: React.ReactNode; text: React.ReactNode }> = ({ icon, text }) => (
  <Container.Grid $gridTemplateColumns="2rem 1fr" $gridGap="0.8rem" $alignItems="start" $padding="0 0 1.2rem 0">
    {icon}
    <Text.Body2>{text}</Text.Body2>
  </Container.Grid>
)

const OnTimeRateCalculationSection: React.FC = () => {
  const isOnMobile = hooks.useIsMediaSize('mobile')
  const comparisonGridColumns = isOnMobile ? '1fr' : '1fr 1fr'

  return (
    <>
      <PanelTitle>
        <LocalizedText translationKey="dweb_dashboard_on_time_rate_calculation_section_how_time_rate_calculated" />
      </PanelTitle>
      <Panel left noPadding>
        <Container.Base $padding="2.4rem" $textAlign="left" $color="neutral-black">
          <Text.Body2>
            <LocalizedText translationKey="dweb_dashboard_on_time_rate_calculation_intro" />
          </Text.Body2>

          <Spacer $height="0.8rem" />

          <Container.Base $padding="0 0 0 1.6rem">
            {STOP_TYPE_KEYS.map((item) => (
              <Container.Grid key={item} $gridTemplateColumns="1.6rem 1fr" $alignItems="center" $padding="0.2rem 0">
                <Text.Body2>•</Text.Body2>
                <Text.Body2>
                  <LocalizedText translationKey={item} />
                </Text.Body2>
              </Container.Grid>
            ))}
          </Container.Base>

          <Spacer $height="2.4rem" />

          <Container.Grid $gridTemplateColumns={comparisonGridColumns} $gridGap="2.4rem">
            <Container.Base>
              <Text.Body2>
                <LocalizedText translationKey="dweb_dashboard_commitment_rate_calculation_section_impacts_rate" />
              </Text.Body2>
              <Spacer $height="1.2rem" />
              {IMPACTS_RATE_KEYS.map((item) => (
                <IconRow
                  key={item}
                  icon={<Icon.Checkmark $width="2rem" $height="2rem" $color="neutral-black" />}
                  text={<LocalizedText translationKey={item} />}
                />
              ))}
            </Container.Base>

            <Container.Base>
              <Text.Body2>
                <LocalizedRichText
                  translationKey="dweb_dashboard_commitment_rate_calculation_section_does_strong_text1_impact_rate"
                  params={{
                    strongText1: (
                      <strong>
                        <LocalizedText translationKey="dweb_dashboard_commitment_rate_calculation_section_not" />
                      </strong>
                    ),
                  }}
                />
              </Text.Body2>
              <Spacer $height="1.2rem" />
              {DOES_NOT_IMPACT_RATE_KEYS.map((item) => (
                <IconRow
                  key={item}
                  icon={<Icon.Close $width="2rem" $height="2rem" $color="neutral-black" />}
                  text={<LocalizedText translationKey={item} />}
                />
              ))}
            </Container.Base>
          </Container.Grid>
        </Container.Base>
      </Panel>
    </>
  )
}

export default OnTimeRateCalculationSection
